import { render, staticRenderFns } from "./subscripePlans.vue?vue&type=template&id=ddfcc6b2&scoped=true&"
import script from "./subscripePlans.vue?vue&type=script&lang=js&"
export * from "./subscripePlans.vue?vue&type=script&lang=js&"
import style0 from "./subscripePlans.vue?vue&type=style&index=0&id=ddfcc6b2&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ddfcc6b2",
  null
  
)

export default component.exports